import React, { useEffect } from "react";
import Header from "components/Common/Header/Header";
import ConditionsListBody from "components/PatientManagement/Conditions/ConditionsListBody";

export default function Conditions() {
  useEffect(() => {
    document.title = "Conditions";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="patientmanagement" />
      <ConditionsListBody />
    </main>
  );
}
